import { AddressFormats } from '../../../constant/AddressFormats';

/**
 * Pure per-country label lookup for the address fields.
 * Same fallback rules as hooks/useAddressFormat.ts, but callable from yup
 * schemas as well as components. Unknown/absent country → AU labels.
 */
export const getAddressFieldLabels = (country?: string) => {
  const format = AddressFormats[country || 'AU'] || AddressFormats['AU'];

  return {
    city: format.city_label || 'City',
    postcode: format.postcode_label || 'Postcode',
    state: format.state_label || 'State',
  };
};
